import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, StoreIcon, TruckIcon } from 'lucide-react';
const hours = [{
  day: 'Mardi – Vendredi',
  value: '9h30 – 12h00 · 14h00 – 18h30'
}, {
  day: 'Samedi',
  value: '9h30 – 17h00'
}, {
  day: 'Dimanche & lundi',
  value: 'Fermé'
}];
export function Contact() {
  return <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6" data-id="element-149" data-mp="1lq0b7vpp9wu2">
      <header className="max-w-2xl" data-id="element-150" data-mp="1lofhg8b7mhx9">
        <h1 className="font-display text-5xl font-extrabold tracking-tight text-encre" data-id="element-151" data-mp="xzw8rro9034n">
          La boutique
        </h1>
        <p className="mt-3 text-lg leading-relaxed text-encre-soft" data-id="element-152" data-mp="t2xgzfs2489m">
          Passez nous voir à Vouziers pour toucher les fils, comparer les coloris et repartir avec
          vos pelotes. Les commandes en ligne sont préparées depuis le même atelier.
        </p>
      </header>

      <div className="mt-10 grid gap-6 lg:grid-cols-3" data-id="element-153" data-mp="f9635v7am283">
        <section className="rounded-3xl bg-white p-7 ring-1 ring-encre/10" data-id="element-154" data-mp="f7v2w5d23clq">
          <h2 className="flex items-center gap-2 font-display text-xl font-extrabold text-encre" data-id="element-155" data-mp="aauvnr4h03t1">
            <MapPinIcon className="h-5 w-5 text-framboise" aria-hidden="true" data-id="element-156" data-mp="15f6sa825t9x1" /> Nous trouver
          </h2>
          <address className="mt-4 space-y-3 not-italic text-sm leading-relaxed text-encre-soft" data-id="element-157" data-mp="19exmklqwa86b">
            <p className="font-semibold text-encre" data-id="element-158" data-mp="1e9trgmh8cq0u">
              Meli Melo Services
              <br data-id="element-159" data-mp="1j621xmkhfv1o" />
              58 rue Chanzy
              <br data-id="element-160" data-mp="mh2to7jwet9h" />
              08400 Vouziers
            </p>
            <p className="flex items-center gap-2" data-id="element-161" data-mp="minqk3toqoai">
              <MailIcon className="h-4 w-4 text-framboise" aria-hidden="true" data-id="element-162" data-mp="qj7kkyiypbsf" />
              <a className="font-semibold text-encre hover:text-framboise-dark" href="mailto:melimelo08@orange.fr" data-id="element-163" data-mp="vgpwmxsa074n">
                melimelo08@orange.fr
              </a>
            </p>
            <p className="flex items-center gap-2" data-id="element-164" data-mp="26weghga8gq18">
              <StoreIcon className="h-4 w-4 text-framboise" aria-hidden="true" data-id="element-165" data-mp="26vwdm0t2fdkc" />
              <a className="font-semibold text-encre hover:text-framboise-dark" href="https://melimeloservices.etsy.com" target="_blank" rel="noreferrer" data-id="element-166" data-mp="2bug3gcas59hz">
                melimeloservices.etsy.com
              </a>
            </p>
          </address>
        </section>

        <section className="rounded-3xl bg-white p-7 ring-1 ring-encre/10" data-id="element-167" data-mp="1w36xzoy6unav">
          <h2 className="flex items-center gap-2 font-display text-xl font-extrabold text-encre" data-id="element-168" data-mp="1r6zstydm9ftz">
            <ClockIcon className="h-5 w-5 text-framboise" aria-hidden="true" data-id="element-169" data-mp="13hdu1c15p2mi" /> Horaires
          </h2>
          <dl className="mt-4 space-y-3 text-sm" data-id="element-170" data-mp="yjm1cfsotch9">
            {hours.map(slot => <div key={slot.day} className="flex flex-col border-b border-encre/8 pb-3 last:border-0 last:pb-0" data-id="element-171" data-mp="1d88dy9qxjq4s">
                <dt className="font-bold text-encre" data-id="element-172" data-mp="18enpp9f52ais">{slot.day}</dt>
                <dd className="text-encre-soft" data-id="element-173" data-mp="kpcmllabg41h">{slot.value}</dd>
              </div>)}
          </dl>
        </section>

        <section className="rounded-3xl bg-encre p-7 text-creme" data-id="element-174" data-mp="fr1cd9g3zriq">
          <h2 className="flex items-center gap-2 font-display text-xl font-extrabold" data-id="element-175" data-mp="2rdll9rt2r47l">
            <TruckIcon className="h-5 w-5 text-framboise" aria-hidden="true" data-id="element-176" data-mp="2w5msv0fas6ra" /> Livraison & retrait
          </h2>
          <ul className="mt-4 space-y-3 text-sm leading-relaxed text-creme/75" data-id="element-177" data-mp="2hhici33pw7bo">
            <li data-id="element-178" data-mp="2mes7dy9vlb6w">Retrait gratuit en boutique sous 24 h ouvrées.</li>
            <li data-id="element-179" data-mp="2md7fkgey46cq">Colissimo suivi : 5,90 € — offert dès 49 € d'achat.</li>
            <li data-id="element-180" data-mp="3a5xm2a42xxfm">Créations au crochet sur commande : 8 à 10 jours de confection.</li>
            <li data-id="element-181" data-mp="3f2whcvzhcafe">Puzzles personnalisés : 5 jours ouvrés après validation du visuel.</li>
          </ul>
        </section>
      </div>

      <section className="mt-6 rounded-4xl bg-framboise-soft p-8 sm:p-10" data-id="element-182" data-mp="316iwrdznfswp">
        <div className="max-w-2xl" data-id="element-183" data-mp="354goangw6r39">
          <h2 className="font-display text-3xl font-extrabold text-encre" data-id="element-184" data-mp="1pparyrl3cas0">Une commande sur mesure ?</h2>
          <p className="mt-2 text-encre-soft" data-id="element-185" data-mp="1tqwdt2flrzec">
            Un doudou dans vos coloris, un quantité précise de pelotes pour un plaid, un puzzle à
            partir de votre photo : écrivez-nous, on vous répond sous 48 h.
          </p>
        </div>

        <form className="mt-6 grid gap-4 sm:grid-cols-2" onSubmit={e => e.preventDefault()} data-id="element-186" data-mp="256iw7ls75j6a">
          <div data-id="element-187" data-mp="2064x4t8kpjke">
            <label htmlFor="nom" className="text-sm font-bold text-encre" data-id="element-188" data-mp="1v94qoh7taesr">Votre nom</label>
            <input id="nom" name="nom" type="text" required className="mt-1.5 w-full rounded-2xl border border-encre/15 bg-white px-4 py-3 text-sm text-encre outline-none focus:border-framboise focus:ring-2 focus:ring-framboise/30" data-id="element-189" data-mp="1v7a2mu18u6kg" />
          </div>
          <div data-id="element-190" data-mp="2exnaskdyn20l">
            <label htmlFor="email" className="text-sm font-bold text-encre" data-id="element-191" data-mp="2ew2f2rfwtd15">Votre e-mail</label>
            <input id="email" name="email" type="email" required className="mt-1.5 w-full rounded-2xl border border-encre/15 bg-white px-4 py-3 text-sm text-encre outline-none focus:border-framboise focus:ring-2 focus:ring-framboise/30" data-id="element-192" data-mp="17kli00kuo005" />
          </div>
          <div className="sm:col-span-2" data-id="element-193" data-mp="3j75h5r80jybt">
            <label htmlFor="projet" className="text-sm font-bold text-encre" data-id="element-194" data-mp="3o5grs464ucv3">Votre projet</label>
            <textarea id="projet" name="projet" rows={4} required className="mt-1.5 w-full rounded-2xl border border-encre/15 bg-white px-4 py-3 text-sm text-encre outline-none focus:border-framboise focus:ring-2 focus:ring-framboise/30" data-id="element-195" data-mp="3swfd5i5za157" />
          </div>
          <button type="submit" className="justify-self-start rounded-full bg-framboise px-6 py-3.5 font-display text-base font-extrabold text-white transition-colors duration-150 ease-out hover:bg-framboise-dark" data-id="element-196" data-mp="asdnsf7z2zsu">
            Envoyer ma demande
          </button>
        </form>
      </section>
    </div>;
}